import React, { Component } from "react";

export default class Select extends Component {
  constructor(props) {
    super(props);
    this.state = { cleared: false, value: "", blank: true };

    this.handleChange = this.handleChange.bind(this);
  }

  handleChange(event) {
    this.setState({ value: event.target.value, blank: false });
    if (this.props.multiple) {
      var options = event.target.options;
      var value = [];
      for (var i = 0, l = options.length; i < l; i++) {
        if (options[i].selected) {
          value.push(options[i].value);
        }
      }
    }
    //this.props.name === "model" ? this.props.slectedValue(value) : "";
  }

  render() {
    const { children, type, name, className, pattern, required, multiple } =
      this.props;
    const { blank, value } = this.state;
    return (
      <label
        htmlFor={name}
        className={`${className} ${value !== "" ? "filled" : "empty"} ${
          required ? "is-required" : ""
        }`}
      >
        <select
          name={`${name}${multiple ? "[]" : ""}`}
          id={name}
          onChange={this.handleChange}
          required={required}
          multiple={multiple}
        >
          {this.props.options &&
            this.props.options.map((option, i) => (
              <option value={option} key={i}>
                {option}
              </option>
            ))}
          {this.props.defaultValue ? (
            <option value={this.props.defaultValue} key={1234}>
              {this.props.defaultValue}
            </option>
          ) : blank ? (
            <option disabled selected value></option>
          ) : (
            ""
          )}
        </select>
        <span>{children}</span>
        <p className="error">Palun täida kõik kohustuslikud väljad!</p>
      </label>
    );
  }
}
